import {
  AuthFeedbacks,
  AuthInitialStateFeedback,
  AuthMethod,
  ManageAuthFeedback,
} from "@interfaces";
import { client } from "@passwordless-id/webauthn";
// import { isMobileOnly } from "react-device-detect";

export function resolveAuthChallengeFeedback({
  authMethod,
  authStep,
  resetToInitialState,
}: ManageAuthFeedback) {
  if (resetToInitialState || !authMethod || !authStep) {
    return AuthInitialStateFeedback;
  } else {
    return AuthFeedbacks[authMethod][authStep];
  }
}

export async function checkIfBiometricAuthIsAvailable() {
  try {
    const canUseLocalAuthenticator = await client.isLocalAuthenticator();
    const isClientAvailable = client.isAvailable();
    return canUseLocalAuthenticator && isClientAvailable;
  } catch (error) {
    console.error("Error verifying biometric auth availability", error);
    return false;
  }
}

export function resolveNoBiometricAuthMethod() {
  // Prefer always email method at desktop and mobile devices
  return AuthMethod.EMAIL;
  // return isMobileOnly ? AuthMethod.PHONE_NUMBER : AuthMethod.EMAIL;
}
